import { render, staticRenderFns } from "./collectionItem.vue?vue&type=template&id=6e6e01af&scoped=true&"
import script from "./collectionItem.vue?vue&type=script&lang=js&"
export * from "./collectionItem.vue?vue&type=script&lang=js&"
import style0 from "./collectionItem.vue?vue&type=style&index=0&id=6e6e01af&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e6e01af",
  null
  
)

export default component.exports